module.exports = "/wp-content/plugins/farmacy/assets/js/images/menu-topicals-icon-2-8096a76d4d8da56070f0b87fff0746c3.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/elo-app/img/category_icons/menu-topicals-icon-2.svg
 ** module id = 1009
 ** module chunks = 1 75
 **/